export default {
  getOrigin: state => state.origin,
  getLoading: state => state.loading,
  getOrderUuid: state => state.orderUuid,
  getRules: state => state.rules,
  getIndexStepsAlreadyVisited: state => state.indexStepsAlreadyVisited,
  getPreviousRoute: state => state.previousRoute,
  coverageStatus: state => state.coverageStatus,
  getCustomerType: state => state.customerType
}
